import cx from 'classnames';
import { CheckCircle, CodeCircle } from 'education-icons';
import React, { PointerEventHandler, useRef } from 'react';

import { Button } from '@edu-frontend/modules/src/components/ui/Button';
import { IconClose } from '@edu-frontend/modules/src/components/ui/Icon';
import { Text } from '@edu-frontend/modules/src/components/ui/Text';
import { useCodingPropsSelector } from '../context';
import { useCodingStore } from '../state';
import { useGetMessage } from './hooks';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './coding-problem__verdict.module.scss';

type CodingVerdictMobileProps = {
    onClose: () => void;
};

export function CodingVerdictMobile(props: CodingVerdictMobileProps) {
    const { onClose } = props;
    const swipeContainerRef = useRef<HTMLDivElement>(null);

    const selectedTest = useCodingStore((s) => s.selectedTest);
    const attempt = useCodingPropsSelector((p) => p.attempt);
    const showCorrectAnswers = useCodingPropsSelector((p) => p.showCorrectAnswers);
    const message = useGetMessage();

    if (showCorrectAnswers) {
        return null;
    }
    const result = attempt?.markers?.result[selectedTest];
    const isCorrect = result?.answer_status;
    if (typeof isCorrect === 'undefined') {
        return null;
    }

    const results = attempt && Object.values(attempt.markers?.result || {});
    const allCorrect = results && results.length > 0 && results.every((r) => r.answer_status);
    if (isCorrect && !allCorrect) {
        // если текущий тест правильный, но в целом задача не решена, сообщение не показываем
        return null;
    }

    if (!message) {
        return null;
    }

    // Закрытие нотификации свайпом
    let downX: number;

    const onPointerMove = (e: PointerEvent) => {
        const newX = e.clientX;

        if (newX - downX > 10 && swipeContainerRef.current) {
            swipeContainerRef.current.className = styles.hide;

            setTimeout(() => {
                onClose();
            }, 500);
        }
    };

    const onPointerDown: PointerEventHandler<HTMLDivElement> = (e) => {
        downX = e.clientX;
        swipeContainerRef.current?.addEventListener('pointermove', onPointerMove);
    };

    const onPointerUp = () => {
        swipeContainerRef.current?.removeEventListener('pointermove', onPointerMove);
    };

    return (
        <div onPointerDown={onPointerDown} onPointerUp={onPointerUp} ref={swipeContainerRef}>
            <div
                className={cx(
                    styles.verdictMobile,
                    allCorrect ? styles.verdictMobile_success : styles.verdictMobile_error
                )}
            >
                <div className={styles.verdictMobile__wrapper}>
                    <div className={styles.verdictMobile__icon}>{allCorrect ? <CheckCircle /> : <CodeCircle />}</div>
                    <Text aria-live="assertive" typography="bodyS" weight="medium">
                        {message}
                    </Text>
                </div>

                <Button
                    aria-label="Закрыть"
                    aria-live="polite"
                    className={styles.verdictMobile__closeButton}
                    icon={() => <IconClose />}
                    onClick={onClose}
                    size="l"
                    view="ghost"
                />
            </div>
        </div>
    );
}
